import { Injectable, Input } from '@angular/core';
import cytoscape from 'cytoscape';
@Injectable({
  providedIn: 'root'
})
export class DbClicService {
  @Input() cy = cytoscape({});
  @Input() focusNode: string;

  constructor() { }

  posizioni(event) {
    let nodoDBClick = event.target;
    if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
      // nodi tra 20 e 200
      var nodiIncomers = nodoDBClick.incomers().sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var nodiOutgoers = nodoDBClick.outgoers().targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      nodiIncomers.run();
      nodiOutgoers.run();
    } else if (nodoDBClick.connectedEdges().toArray().length > 200 && nodoDBClick.connectedEdges().toArray().length < 500) {
      // nodi > 200
      var nodiIncomers = nodoDBClick.incomers().sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var nodiOutgoers = nodoDBClick.outgoers().targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      nodiIncomers.run();
      nodiOutgoers.run();
    } else if (nodoDBClick.connectedEdges().toArray().length >= 500) {
      var nodiIncomers = nodoDBClick.connectedEdges().connectedNodes().layout({
        name: 'random'
      });
      nodiIncomers.run();
    }
    else {
      // nodi < 20
      nodoDBClick.incomers().sources().positions(function (nodi, i) {
        var xc = nodoDBClick.position('x');
        var yc = nodoDBClick.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc + 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      nodoDBClick.outgoers().targets().positions(function (nodi, i) {
        var xc = nodoDBClick.position('x');
        var yc = nodoDBClick.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc - 75;
        return {
          x: xRet,
          y: yRet
        };
      });
    }
  }

  posizioneFormDistanza(elemSessionStorage) {
    if (elemSessionStorage.connectedEdges().toArray().length > 20 && elemSessionStorage.connectedEdges().toArray().length < 200) {
      // nodi tra 20 e 200
      var nodiIncomers = elemSessionStorage.incomers().sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var nodiOutgoers = elemSessionStorage.outgoers().targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      nodiIncomers.run();
      nodiOutgoers.run();
    } else if (elemSessionStorage.connectedEdges().toArray().length > 200 && elemSessionStorage.connectedEdges().toArray().length < 1000) {
      // nodi > 200
      var nodiIncomers = elemSessionStorage.incomers().sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var nodiOutgoers = elemSessionStorage.outgoers().targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      nodiIncomers.run();
      nodiOutgoers.run();
      // nodi > 500
    } else if(elemSessionStorage.connectedEdges().toArray().length > 1000){
      // var nodiConnessi = elemSessionStorage.connectedEdges().connectedNodes().layout({
      //   name: 'random'
      // });
      // nodiConnessi.run();

    } else{
    // IPERONIMI sopra
    let ipe2Liv = elemSessionStorage.outgoers('[relationType= "hyponym"]').targets().outgoers('[relationType= "hyponym"]');

    elemSessionStorage.outgoers('[relationType = "hyponym"]').targets().positions(function (nodi, i) {
      var xc = elemSessionStorage.position('x');
      var yc = elemSessionStorage.position('y');
      var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
      var yRet = yc - 75;
      return {
        x: xRet,
        y: yRet
      };
    });
    
    elemSessionStorage.successors('[relationType = "hyponym"]').targets().positions(function (nodi, i) {
      var xc = elemSessionStorage.successors('[relationType = "hyponym"]').targets().position('x');
      var yc = elemSessionStorage.successors('[relationType = "hyponym"]').targets().position('y');
      var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * i);
      var yRet = i % 2 == 1 ? (yc - 75 * i) : (yc - 75 * i);
      return {
        x: xRet,
        y: yRet
      };
    });

    //  IPONIMI sotto
    let ipo2Liv = elemSessionStorage.incomers('[relationType= "hyponym"]').sources().incomers('[relationType= "hyponym"]');
    elemSessionStorage.incomers('[relationType= "hyponym"]').sources().positions(function (nodi, i) {
      var xc = elemSessionStorage.position('x');
      var yc = elemSessionStorage.position('y');
      var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
      var yRet = yc + 75;
      return {
        x: xRet,
        y: yRet
      };
    });

    for (var i = 0; i < ipo2Liv.sources().toArray().length; i++) {
      if (ipo2Liv[i].target() !== elemSessionStorage) {
        ipo2Liv.sources().positions(function (nodi, i) {
          var xc = ipo2Liv[i].target().position('x');
          var yc = ipo2Liv[i].target().position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc + 75;
          return {
            x: xRet,
            y: yRet
          };
        });
      }
    }

    // OLONIMI sopra
    let olo = elemSessionStorage.outgoers('[relationType= "partMeronym"]').targets().outgoers('[relationType= "partMeronym"]');
    elemSessionStorage.outgoers('[relationType= "partMeronym"]').targets().positions(function (nodi, i) {
      var xc = elemSessionStorage.position('x');
      var yc = elemSessionStorage.position('y');
      var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
      var yRet = yc - 75;
      return {
        x: xRet,
        y: yRet
      };
    });
    
    for (var i = 0; i < olo.targets().toArray().length; i++) {
      if (olo[i].source() !== elemSessionStorage) {
        olo.targets().positions(function (nodi, i) {
          var xc = olo[i].source().position('x');
          var yc = olo[i].source().position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc - 75;
          return {
            x: xRet,
            y: yRet
          };
        });
      }
    }

  // MERONIMI sotto
    let mero = elemSessionStorage.incomers('[relationType= "partMeronym"]').sources().incomers('[relationType= "partMeronym"]');
    elemSessionStorage.incomers('[relationType= "partMeronym"]').sources().positions(function (nodi, i) {
      var xc = elemSessionStorage.position('x');
      var yc = elemSessionStorage.position('y');
      var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
      var yRet = yc + 75;
      return {
        x: xRet,
        y: yRet
      };
    });

    for (var i = 0; i < mero.sources().toArray().length; i++) {
      if (mero[i].target() !== elemSessionStorage) {
        mero.sources().positions(function (nodi, i) {
          var xc = mero[i].target().position('x');
          var yc = mero[i].target().position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc + 75;
          return {
            x: xRet,
            y: yRet
          };
        });
      }
    }
  }
}
}
